import React from 'react';

export const ContactArrow = () => {
  return (
    <span className="contact-arrow">
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 11.6265L11.253 1.37352M11.253 1.37352L1.37846 1.37352M11.253 1.37352V11.248"
          stroke="#9A252D"
          stroke-width="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};
